import axiosInstance from "../../api/axiosInstance";

let getCurrencies = (token) => {
    return new Promise((resolve, reject) => { 
        axiosInstance.get(process.env.REACT_APP_API + "/espacios/monedas").then(response=> {
            resolve(response);
        }).catch(error => {
            console.log(error);
            resolve(error.response);
        });
    })
}

export default getCurrencies